import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { ThemeProvider } from '@mui/material';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { StyleSheetManager } from '@uikit/lib/StylesheetManager';
import { aibTheme } from '@uikit/Theme/Theme';
import * as S from './App.styled';

/**
 * Hide Medlallia Feedback button inside of My Mortgage.
 */
const HideMedalliaStyle = createGlobalStyle`
  #kampyleButtonContainer {
    display: none;
  }

  #formLightboxContainer {
    display: none;
  }
`;

export function Styles({ children }) {
  return (
    <StyleSheetManager>
      <StyledThemeProvider theme={aibTheme}>
        <ThemeProvider theme={aibTheme}>
          <HideMedalliaStyle />
          <S.GlobalAppStyles />
          <S.GlobalFontFamilyStyles />
          {children}
        </ThemeProvider>
      </StyledThemeProvider>
    </StyleSheetManager>
  );
}
